export const DEFAULT_AUTH_USER = {
 
  userType: "",
  userName: "",
  chamberId: "",
  userId: "",
 
  
};

export const DEFAULT_THEME = "default";

export const DEFAULT_JOB_CATEGORIES = [
  {
    title: "IT/Computing",
    value: "IT/Computing",
  },
  {
    title: "Real Estate",
    value: "Real Estate",
  },
  {
    title: "Agriculture",
    value: "Agriculture",
  },
  {
    title: "Banking",
    value: "Banking",
  },
  {
    title: "Marketing & Sales",
    value: "Marketing & Sales",
  },
];

export const DEFAULT_JOB_TYPES = [
  {
    title: "Full Time",
    value: 1,
  },
  {
    title: "Part Time",
    value:2,
  },
  
];

export const DEFAULT_JOB_LEVELS = [
  {
    title: "Top Level",
    value:3,
  },
  {
    title: "Mid Level",
    value: 2,
  },
  {
    title: "Entry Level",
    value:1,
  },
];

export const ImagesAssets = {
  logo1: require('../../../assets/sel.png'),
  logo2: require('../../../assets/blr.png'),
  logo3: require('../../../assets/jc.png'),
 
};

//export const years = createTable();

export const Alldate_Format = "Do MMM , YYYY";
// export const apiPath = "http://jpapi.vertexwebsurf.com/api";
//export const apiPath = "https://adminapi.loginjobs.com/public/api";
//export const apiPathp = "http://adminapi.loginjobs.com/public/api";
//export const apiPathn = "https://loginjobs.com/public/api";
//export const apiPathLocal = "http://localhost:30227/Api";
export const apiPathLocal = "http://192.168.0.117:30227/Api";